module.exports = __webpack_public_path__ + "static/media/Screenshot--player.cc04ff64.png";